import type { CheckoutEvidence } from '../../models/insuranceIndication'

export interface CheckoutEvidenceRow {
  label: string
  value: string
}

/**
 * Keys are camelCase because every response runs through `camelizeKeys`, which
 * camelizes nested payloads too — the backend writes `end_user_ip`.
 */
const LABELS: [key: string, label: string][] = [
  ['capturedAt', 'Captured'],
  ['endUserIp', 'IP address'],
  ['endUserUserAgent', 'Browser'],
  ['pageUrl', 'Page'],
  ['referrer', 'Referrer'],
  ['timezone', 'Timezone'],
  ['language', 'Language'],
  ['platform', 'Platform'],
]

function formatted(key: string, value: unknown): string {
  if (key === 'capturedAt') return new Date(String(value)).toLocaleString()
  return String(value)
}

/** What the capture says about the checkout, in the order it answers "who, from where, when". */
export function checkoutEvidenceRows(evidence: CheckoutEvidence): CheckoutEvidenceRow[] {
  const rows: CheckoutEvidenceRow[] = []
  if (evidence.appliedAt) {
    rows.push({ label: 'Applied', value: new Date(evidence.appliedAt).toLocaleString() })
  }
  for (const [key, label] of LABELS) {
    const value = evidence.clientContext[key]
    if (value) rows.push({ label, value: formatted(key, value) })
  }
  const width = evidence.clientContext.viewportWidth
  const height = evidence.clientContext.viewportHeight
  if (width && height) {
    rows.push({ label: 'Viewport', value: `${String(width)} × ${String(height)}` })
  }
  return rows
}

/** The snapshot of the page behind the screenshot, newest first. */
export function domSnapshots(evidence: CheckoutEvidence) {
  return evidence.captures.filter((capture) => capture.attachmentType === 'CHECKOUT_DOM_SNAPSHOT')
}

export function screenshots(evidence: CheckoutEvidence) {
  return evidence.captures.filter((capture) => capture.attachmentType === 'CHECKOUT_SCREENSHOT')
}
